import React, { useEffect, useRef } from "react";
import { motion, useAnimation, useInView } from "framer-motion";

export default function Presentation({ dimension = "150" }) {
  const controls = useAnimation();
  const iconRef = useRef(null);
  const isInView = useInView(iconRef, { once: true });
  useEffect(() => {
    if (isInView) {
      controls.start("visible");
    }
  }, [isInView]);

  const iconPath = {
    hidden: {
      pathLength: 0,
      stroke: "var(--secondary)",
    },
    visible: {
      pathLength: 1,
      stroke: [
        "var(--secondary)",
        "var(--secondary)",
        "var(--secondary)",
        "var(--secondary)",
        "var(--primary)",
      ],
      transition: {
        duration: 2,
        ease: "easeInOut",
      },
    },
  };
  return (
    <motion.svg
      width={dimension}
      height={dimension}
      viewBox="0 0 500 500"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      ref={iconRef}
      initial="hidden"
      animate={controls}
    >
      <g clipPath="url(#clip0_117_71)">
        <motion.path
          variants={iconPath}
          strokeWidth="10"
          d="M500 33.3333H258.333V8.33333C258.333 3.725 254.6 0 250 0C245.4 0 241.667 3.725 241.667 8.33333V33.3333H0V383.333H229.883L127.442 485.775C124.183 489.033 124.183 494.3 127.442 497.558C129.067 499.183 131.2 500 133.333 500C135.467 500 137.6 499.183 139.225 497.558L241.667 395.117V475C241.667 479.608 245.4 483.333 250 483.333C254.6 483.333 258.333 479.608 258.333 475V395.117L360.775 497.558C362.4 499.183 364.533 500 366.667 500C368.8 500 370.933 499.183 372.558 497.558C375.817 494.3 375.817 489.033 372.558 485.775L270.117 383.333H500V33.3333ZM483.333 366.667H16.6667V50H483.333V366.667Z"
        />
        <motion.path
          variants={iconPath}
          strokeWidth="10"
          d="M345.667 206.517C345.517 204.525 345.275 202.567 345 200.617C344.833 199.433 344.667 198.25 344.458 197.075C344.067 194.883 343.575 192.733 343.042 190.592C342.8 189.633 342.575 188.667 342.3 187.717C341.667 185.508 340.933 183.342 340.15 181.2C339.817 180.283 339.5 179.358 339.142 178.45C338.342 176.442 337.433 174.492 336.5 172.558C336 171.525 335.533 170.475 335 169.458C334.142 167.833 333.2 166.275 332.25 164.708C331.492 163.442 330.767 162.158 329.95 160.925C329.217 159.833 328.408 158.8 327.633 157.733C326.483 156.15 325.367 154.55 324.117 153.033L324.1 153.017C322.158 150.658 320.133 148.367 317.958 146.192C315.875 144.108 313.675 142.183 311.425 140.317C311.308 140.225 311.208 140.117 311.1 140.025C309.658 138.842 308.142 137.783 306.642 136.692C305.5 135.842 304.375 134.958 303.175 134.167C302.042 133.417 300.858 132.75 299.7 132.05C298.025 131.033 296.342 130.025 294.6 129.108C293.692 128.633 292.75 128.217 291.825 127.767C289.783 126.775 287.708 125.825 285.583 124.975C284.767 124.65 283.942 124.375 283.125 124.075C280.9 123.258 278.65 122.5 276.35 121.842C275.45 121.583 274.533 121.367 273.625 121.142C271.458 120.592 269.275 120.1 267.05 119.7C265.875 119.483 264.683 119.325 263.5 119.158C261.567 118.892 259.633 118.658 257.667 118.5C256.167 118.383 254.658 118.317 253.15 118.275C252.167 118.242 251.2 118.125 250.208 118.125C249.458 118.125 248.725 118.217 247.975 118.242C247.242 118.258 246.517 118.192 245.775 118.225L242.483 118.425L242.4 118.517C193.208 122.517 154.375 163.75 154.375 213.958C154.375 266.8 197.367 309.792 250.208 309.792C274.2 309.792 296.108 300.867 312.942 286.233C313.175 286.05 313.458 285.967 313.675 285.75C313.808 285.617 313.85 285.442 313.975 285.3C331.683 269.458 343.492 247.208 345.633 222.183L345.792 222.05L345.958 218.383C345.992 217.65 345.925 216.933 345.942 216.2C345.942 215.45 346.042 214.717 346.042 213.958C346.042 212.942 345.917 211.95 345.892 210.942C345.842 209.458 345.783 207.992 345.667 206.517ZM254.375 135C255.2 135.042 256.033 135.058 256.858 135.125C257.725 135.192 258.592 135.275 259.45 135.375C261.342 135.6 263.208 135.883 265.058 136.233C265.617 136.342 266.175 136.433 266.733 136.55C269 137.033 271.242 137.6 273.433 138.275C273.567 138.317 273.708 138.35 273.842 138.392C298.525 146.125 318.042 165.642 325.775 190.325C325.817 190.458 325.85 190.6 325.892 190.733C326.567 192.925 327.133 195.158 327.617 197.433C327.733 197.992 327.825 198.55 327.933 199.108C328.283 200.958 328.567 202.825 328.792 204.717C328.892 205.575 328.967 206.442 329.042 207.308C329.108 208.125 329.125 208.967 329.167 209.792H254.375V135ZM171.042 213.958C171.042 174.567 199.992 141.9 237.708 135.875V217.817L237.717 218.075C237.717 218.117 237.725 218.15 237.725 218.192L238.017 226.458H242.592L295.175 279.042C282.392 287.9 266.908 293.125 250.208 293.125C206.558 293.125 171.042 257.608 171.042 213.958ZM307.8 268.1L266.158 226.458H328.292C325.742 242.433 318.425 256.817 307.8 268.1Z"
        />
      </g>
      <defs>
        <clipPath id="clip0_117_71">
          <rect width="500" height="500" />
        </clipPath>
      </defs>
    </motion.svg>
  );
}
